import { render, staticRenderFns } from "./ModalItems.vue?vue&type=template&id=98954a5a&"
import script from "./ModalItems.vue?vue&type=script&lang=js&"
export * from "./ModalItems.vue?vue&type=script&lang=js&"
import style0 from "./ModalItems.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports